// "Public lists" on a public profile. Receives only PUBLIC lists from the API;
// private lists are never sent, so a profile with none simply omits the section.
import { Link } from 'react-router-dom';
import { formatListMeta } from '../../utils/myListItems';
import styles from './PublicListsSection.module.css';

export default function PublicListsSection({ lists = [], username, heading = 'Public lists', as: Tag = 'section', className = '' }) {
    if (!lists.length) return null;
    return (
        <Tag className={`${styles.section} ${className}`} aria-labelledby={`public-lists-${username}`}>
            <h2 id={`public-lists-${username}`} className={styles.heading}>{heading}</h2>
            <ul className={styles.grid}>
                {lists.map((list) => (
                    <li key={list.id}>
                        <Link to={`/l/${list.shareSlug}`} className={styles.card} aria-label={`${list.name}, ${formatListMeta(list)}`}>
                            <span className={styles.stack} aria-hidden="true">
                                {(list.previewPosters ?? []).slice(0, 3).map((url, index) => (
                                    <img key={`${url}-${index}`} src={url} alt="" className={styles.poster} style={{ left: index * 16, zIndex: 10 - index }} loading="lazy" />
                                ))}
                                {!(list.previewPosters ?? []).length && <span className={styles.stackEmpty}>🎬</span>}
                            </span>
                            <span className={styles.body}>
                                <span className={styles.name}>{list.name}</span>
                                <span className={styles.meta}>{formatListMeta(list)}</span>
                                {list.description && <span className={styles.description}>{list.description}</span>}
                            </span>
                        </Link>
                    </li>
                ))}
            </ul>
        </Tag>
    );
}
